import menuStyle from "./menu.module.css"


export default function Menu(props) {

    const selectTab = props['selectTab']
    const Set_selectTab = props['Set_selectTab']

    return(
        Array
        .from(['일정', '공지'])
        .map((value, index) => {
            return(
                <div
                    key={index}
                    className={menuStyle['menuButton']}
                >
                    <div
                        className={selectTab === index ? menuStyle['select'] : null}
                        onClick={() => Set_selectTab(index)}
                    >{value}</div>
                </div>
            )
        })
    )
}